<template>
  <div class="tooltips-model">
    <el-popover placement="top-start" trigger="click">
      <pre :id="'result-' + id" class="result"></pre>
      <em class="iconfont" slot="reference">
        <slot name="reference"></slot>
      </em>
    </el-popover>
  </div>
</template>
<script>
const syntaxHighlight = (json) => {
  if (typeof json !== "string") {
    json = JSON.stringify(json, undefined, 2);
  }
  json = json.replace(/&/g, "&").replace(/</g, "<").replace(/>/g, ">");
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function (match) {
      // eslint-disable-line
      let cls = "number";
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "key";
        } else {
          cls = "string";
        }
      } else if (/true|false/.test(match)) {
        cls = "boolean";
      } else if (/null/.test(match)) {
        cls = "null";
      }
      return '<span class="' + cls + '">' + match + "</span>";
    }
  );
};
export default {
  name: "tooltips",
  data() {
    return {};
  },
  props: {
    JSON: Object,
    id: Number,
  },
  mounted() {
    $(`#result-${this.id}`).html(syntaxHighlight(this.JSON));
  },
};
</script>

<style lang="scss" rel="stylesheet/scss">
.el-popover {
  .result {
    border: 0;
    padding: 5px;
    background: #fff;
    font-size: 12px;
  }
  .string {
    color: green;
  }
  .number {
    color: darkorange;
  }
  .boolean {
    color: blue;
  }
  .null {
    color: magenta;
  }
  .key {
    color: red;
  }
}
</style>
